import script from "./ContentViewer.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentViewer.vue?vue&type=script&lang=ts&setup=true"

import "./ContentViewer.vue?vue&type=style&index=0&id=a382b422&lang=scss"

const __exports__ = script;

export default __exports__